import React from 'react';
export const portalContext = React.createContext(() => () => {
    throw new Error();
});
const getId = (portals) => portals.map((x) => x.key).join(',');
export const Portals = React.memo(({ portals }) => {
    return React.createElement(React.Fragment, null, portals);
}, (prev, next) => {
    return getId(prev.portals) === getId(next.portals);
});
//# sourceMappingURL=Portals.js.map